// src/pages/Restore.js
import React, { Fragment } from "react";
import { useLocation } from "react-router-dom";
import SendRestore from "./SendRestore";
import PasswordRestore from "./PasswordRestore";

const Restore = () => {
  const { pathname } = useLocation();

  const tokenMatch = pathname.match(/^\/password\/restore\/([^/]+)$/);

  if (pathname === "/password/restore") {
    return (
      <Fragment>
        <h1 className="d-flex justify-content-center align-items-center">
          Restaurar contraseña
        </h1>
        <SendRestore />
      </Fragment>
    );
  }

  if (tokenMatch) {
    const token = tokenMatch[1];
    return (
      <Fragment>
        <h1 className="d-flex justify-content-center align-items-center">
          Restablecer contraseña
        </h1>
        <PasswordRestore token={token} />
      </Fragment>
    );
  }

  return null;
};

export default Restore;
